/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [采购售后退换货列表↗](http://yapi.yishou.com/project/128/interface/api/29941) 的 **请求配置**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @请求头 `POST /erp/reject/rejectList`
 * @更新时间 `2021-09-18 10:28:09`
 */
const rejectListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/reject/rejectList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["get_search_options", "page", "page_size"],
        properties: {
            get_search_options: {
                type: "string",
                description: "是否返回查询条件  1 是 0 否；  为1时 ，仅返回 data-查询条件； 为0 时，仅返回 data ",
            },
            reject_id: { type: "string", description: "退货单号" },
            work_id: { type: "string", description: "工单" },
            dbid: { type: "string", description: "打标" },
            woid: { type: "string", description: "采购订单" },
            "city[]": { type: "string", description: "城市" },
            "market_id[]": { type: "string", description: "子市场" },
            pgname: { type: "string", description: "采购组" },
            supply_name: { type: "string", description: "供应商" },
            goods_no: { type: "string", description: "商品货号" },
            sku: { type: "string", description: "sku" },
            stock_out_admin: { type: "string", description: "出库人" },
            reject_status: { type: "string", description: "状态" },
            blp_type: { type: "string", description: "不良品类型" },
            supply_deal_way: { type: "string", description: "处理方式" },
            "pre_label[]": { type: "string", description: "预处理方式" },
            referer_type: { type: "string", description: "来源" },
            dgid: { type: "string", description: "次品组" },
            dpc_id: { type: "string", description: "退换货负责人" },
            "create_time[]": { type: "string", description: '生成时间create_time["开始时间","结束时间"]' },
            page: { type: "string", description: "页码" },
            page_size: { type: "string", description: "每页展示条数" },
            is_excel: { type: "string", description: "是否导出 0 否  1 是" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        reject_detail_id: { type: "string" },
                        create_time: { type: "string" },
                        update_time: { type: "string" },
                        deal_admin: { type: "string" },
                        price: { type: "string" },
                        stock_out_create_admin: { type: "string" },
                        stock_out_create_time: { type: "string" },
                        woid: { type: "string" },
                        reject_detail_status: { type: "string" },
                        reject_detail_supply_deal_way: { type: "string" },
                        dpc_id: { type: "string" },
                        dbid: { type: "string" },
                        reject_id: { type: "string" },
                        work_id: { type: "string" },
                        referer_type: { type: "string" },
                        supply_name: { type: "string" },
                        supply_area_id: { type: "string" },
                        supply_floor: { type: "string" },
                        market_name: { type: "string" },
                        pgname: { type: "string" },
                        blp_type: { type: "string" },
                        blp_note: { type: "string" },
                        dgm_name: { type: "string" },
                        dg_group_name: { type: "string" },
                        wo_create_time: { type: "string" },
                        sku: { type: "string" },
                        si_val: { type: "string" },
                        co_val: { type: "string" },
                        owe_id: { type: "string" },
                        second_reson_text: { type: "null" },
                        first_reson_text: { type: "null" },
                        service_order_handle_type: { type: "string" },
                        service_order_handle_status: { type: "string" },
                        goods_name: { type: "string" },
                        goods_img: { type: "string" },
                        goods_no: { type: "string" },
                        da_biao_create_time: { type: "string" },
                        da_biao_create_admin: { type: "string" },
                        dir_dbid: { type: "null" },
                        stock_in_time: { type: "string" },
                        stock_in_record_where: { type: "string" },
                        blp_type2: { type: "string" },
                        blp_note2: { type: "string" },
                        reason_id: { type: "string" },
                        tally_admin: { type: "string" },
                        sir_admin: { type: "string" },
                        dbr_dbid: { type: "null" },
                        dbr_create_time: { type: "string" },
                        dpc_name: { type: "string" },
                        supply_area: { type: "string" },
                        reason: { type: "string" },
                        problem_type: { type: "string" },
                        pre_label: { type: "string" },
                        pre_remark: { type: "string" },
                        pre_create_time: { type: "string" },
                        pre_admin_name: { type: "string" },
                        out_time: { type: "string" },
                    },
                },
            },
            count: { type: "number", description: "总条数" },
        },
    },
    requestFunctionName: "rejectList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [采购售后退换货列表↗](http://yapi.yishou.com/project/128/interface/api/29941) 的 **请求函数**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @请求头 `POST /erp/reject/rejectList`
 * @更新时间 `2021-09-18 10:28:09`
 */
export const rejectList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(rejectListRequestConfig, requestData), ...args);
};
rejectList.requestConfig = rejectListRequestConfig;
/**
 * 接口 [售后打标↗](http://yapi.yishou.com/project/128/interface/api/33509) 的 **请求配置**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/Work/confirmDaBiao`
 * @更新时间 `2022-04-28 13:41:06`
 */
const confirmDaBiaoRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Work/confirmDaBiao",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "work_id",
            "reg_type",
            "problem_id",
            "detail[0][num]",
            "detail[0][blp_type]: 0",
            "back_express_no",
            "desk_no",
        ],
        properties: {
            work_id: { type: "string", description: "工单id" },
            reg_type: { type: "string", description: "登记类型" },
            problem_id: { type: "string", description: "问题类型id" },
            "detail[0][num]": { type: "string", description: "打标详情-打标数量" },
            "detail[0][blp_type]: 0": { type: "string", description: "打标详情-不良品类型" },
            back_express_no: { type: "string", description: "快递单号" },
            desk_no: { type: "string", description: "工单台" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            print_data: {
                type: "object",
                properties: {
                    cmd: { type: "string" },
                    requestID: { type: "number" },
                    version: { type: "string" },
                    task: {
                        type: "object",
                        properties: {
                            taskID: { type: "string" },
                            preview: { type: "boolean" },
                            previewType: { type: "string" },
                            firstDocumentNumber: { type: "number" },
                            totalDocumentCount: { type: "number" },
                            documents: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        documentID: { type: "string" },
                                        contents: {
                                            type: "array",
                                            items: {
                                                type: "object",
                                                properties: {
                                                    data: {
                                                        type: "object",
                                                        properties: {
                                                            goods_name: { type: "string" },
                                                            dbid: { type: "string" },
                                                            sku: { type: "string" },
                                                            tag1: { type: "string" },
                                                            tag2: { type: "string" },
                                                            space: { type: "string" },
                                                            goods_no: { type: "string" },
                                                            sku_id: { type: "string" },
                                                            qr_code: { type: "string" },
                                                            pgname: { type: "string" },
                                                            sort_no: { type: "string" },
                                                            img_url: { type: "string" },
                                                            co_val: { type: "string" },
                                                            si_val: { type: "string" },
                                                            parts_img: { type: "string" },
                                                            suit_img: { type: "string" },
                                                            hg_group: { type: "string" },
                                                            goods_kh: { type: "string" },
                                                            mark: { type: "string" },
                                                        },
                                                    },
                                                    templateURL: { type: "string" },
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
            tally_num: { type: "number" },
            can_exchange_num: { type: "string", tag: "爆版4.23.0", description: "可退数量" },
        },
        required: ["can_exchange_num"],
    },
    requestFunctionName: "confirmDaBiao",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [售后打标↗](http://yapi.yishou.com/project/128/interface/api/33509) 的 **请求函数**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /erp/Work/confirmDaBiao`
 * @更新时间 `2022-04-28 13:41:06`
 */
export const confirmDaBiao = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(confirmDaBiaoRequestConfig, requestData), ...args);
};
confirmDaBiao.requestConfig = confirmDaBiaoRequestConfig;
/**
 * 接口 [获取退换货报表↗](http://yapi.yishou.com/project/128/interface/api/33578) 的 **请求配置**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @标签 `爆版4.24.0`, `#2619退换货报表优化`
 * @请求头 `POST /erp/Reject/getRejectDateLogReport`
 * @更新时间 `2022-06-20 14:52:31`
 */
const getRejectDateLogReportRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Reject/getRejectDateLogReport",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_id", "start_time", "end_time", "page", "page_size", "is_excel", "dg_member_id"],
        properties: {
            supply_id: { type: "string", description: "供应商Id" },
            start_time: { type: "string", description: "开始时间" },
            end_time: { type: "string", description: "结束时间" },
            page: { type: "string", description: "页码" },
            page_size: { type: "string", description: "每页加载数量" },
            is_excel: { type: "string", description: "是否导出报表 1=是 0=否" },
            city: { type: "string", description: "城市" },
            pgid: { type: "string", description: "采购组" },
            market_id: { type: "string", description: "市场id" },
            dg_member_id: { type: "string", description: "次品员id" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            totalDetail: {
                type: "object",
                properties: {
                    total_return: { type: "string", description: '"192/11066.00"' },
                    owe_pending: { type: "string", description: '"125/6982.00"' },
                    owe_processed: { type: "string", description: '"45/2927.00"' },
                    refund: { type: "string", description: '"6/324.00"' },
                    stagnant_debts: { type: "string", description: '"5/261.00"' },
                    bad_debt: { type: "string", description: '"5/261.00"' },
                    deduct: { type: "string", description: '"5/261.00"' },
                    deduct_debt: { type: "string", description: '"10/522.00"' },
                },
                additionalProperties: false,
            },
            reportDetailList: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: '"228"' },
                        supply_id: { type: "string", description: '"72652"' },
                        supply_name: {
                            type: "string",
                            description: '"2-A-我是测试档口号我口我A是测试档口号啊啊-鎏新征程LIULIULIU鎏新征程LIU"',
                        },
                        report_date: { type: "string", description: '"2022-06-16"' },
                        total_return: { type: "string", description: '"2/66.00"' },
                        owe_pending: { type: "string", description: '"2/66.00"' },
                        owe_processed: { type: "string", description: '"0/0.00"' },
                        refund: { type: "string", description: '"0/0.00"' },
                        stagnant_debts: { type: "string", description: '"0/0.00"' },
                        bad_debt: { type: "string", description: '"0/0.00"' },
                        deduct: { type: "string", description: '"0/0.00"' },
                        deduct_debt: { type: "string", description: '"0/0.00"' },
                        city: { type: "string", description: '"广州"' },
                        market_name: { type: "string", description: '"广州十三行"' },
                        pg_name: { type: "string", description: '"继明广州采购组"' },
                        dg_name: { type: "string", description: '"刘继明"' },
                        referer_type_text: { type: "string", description: '"售后"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"id":"228","supply_id":"72652","supply_name":"2-A-我是测试档口号我口我A是测试档口号啊啊-鎏新征程LIULIULIU鎏新征程LIU","report_date":"2022-06-16","total_return":"2/66.00","owe_pending":"2/66.00","owe_processed":"0/0.00","refund":"0/0.00","stagnant_debts":"0/0.00","bad_debt":"0/0.00","deduct":"0/0.00","deduct_debt":"0/0.00","city":"广州","market_name":"广州十三行","pg_name":"继明广州采购组","dg_name":"刘继明","referer_type_text":"售后"}]',
            },
            total: { type: "string", description: '"1"' },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getRejectDateLogReport",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取退换货报表↗](http://yapi.yishou.com/project/128/interface/api/33578) 的 **请求函数**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @标签 `爆版4.24.0`, `#2619退换货报表优化`
 * @请求头 `POST /erp/Reject/getRejectDateLogReport`
 * @更新时间 `2022-06-20 14:52:31`
 */
export const getRejectDateLogReport = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getRejectDateLogReportRequestConfig, requestData), ...args);
};
getRejectDateLogReport.requestConfig = getRejectDateLogReportRequestConfig;
/**
 * 接口 [获取报表详情↗](http://yapi.yishou.com/project/128/interface/api/33579) 的 **请求配置**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @标签 `爆版4.24.0`
 * @请求头 `POST /erp/Reject/getRejectDateDetail`
 * @更新时间 `2022-06-21 09:30:21`
 */
const getRejectDateDetailRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Reject/getRejectDateDetail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["reject_date_log_id", "set_type", "goods_no", "sku", "dbid", "page", "page_size", "is_excel"],
        properties: {
            reject_date_log_id: { type: "string" },
            set_type: {
                type: "string",
                description: " 数据类别枚举 {0:重新计算所有, 1:总退换货（数量/金额） , 2:转欠货待处理（数量/金额）, 3.转欠货已换回（数量/金额） ,4.退款（数量/金额）,5.转呆账（数量/金额）,6.转坏账（数量/金额）,7.转抵扣 （数量/金额）}",
            },
            goods_no: { type: "string", description: "" },
            sku: { type: "string", description: "" },
            dbid: { type: "string", description: "" },
            page: { type: "string", description: "" },
            page_size: { type: "string", description: "" },
            is_excel: { type: "string", description: "" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        reject_detail_id: { type: "string", description: '"2377"' },
                        dbid: { type: "string", description: '"20074527"' },
                        goods_img: {
                            type: "string",
                            description: '"obs/goods/img/model/2022/2/11/2767a1a30b6dedbfcf9b800242fd888c.jpg"',
                        },
                        goods_kh: { type: "string", description: '"子画的专卖商品1"' },
                        goods_no: { type: "string", description: '"1213000007"' },
                        sku: { type: "string", description: '"27312102"' },
                        co_val: { type: "string", description: '"格鲁特2"' },
                        si_val: { type: "string", description: '"110"' },
                        woid: { type: "string", description: '"18819"' },
                        woiid: { type: "string", description: '"43631"' },
                        price: { type: "string", description: '"121.00"' },
                        supply_id: { type: "string", description: '"131092"' },
                        create_time: { type: "string", description: '"1644737278"' },
                        supply_deal_way: { type: "string", description: '"2"' },
                        supply_deal_way_formal: { type: "string", description: '"转欠货"' },
                        create_time_formal: { type: "string", description: '"2022-02-13 15:27:58"' },
                        dgMemberName: { type: "string", description: '"刘继明"' },
                        supplyName: { type: "string", description: '"5-B-子画的第二家买手小店-子画大牌"' },
                        market_name: { type: "string", description: '"新中仁"' },
                        pgname: { type: "string", description: '"继明广州采购组"' },
                        pgMenberName: { type: "string", description: '"邓如貂"' },
                        referer_type_text: { type: "string", description: '"采购"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"reject_detail_id":"2377","dbid":"20074527","goods_img":"obs/goods/img/model/2022/2/11/2767a1a30b6dedbfcf9b800242fd888c.jpg","goods_kh":"子画的专卖商品1","goods_no":"1213000007","sku":"27312102","co_val":"格鲁特2","si_val":"110","woid":"18819","woiid":"43631","price":"121.00","supply_id":"131092","create_time":"1644737278","supply_deal_way":"2","supply_deal_way_formal":"转欠货","create_time_formal":"2022-02-13 15:27:58","dgMemberName":"刘继明","supplyName":"5-B-子画的第二家买手小店-子画大牌","market_name":"新中仁","pgname":"继明广州采购组","pgMenberName":"邓如貂","referer_type_text":"采购"}]',
            },
            total: { type: "integer", description: "8" },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getRejectDateDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取报表详情↗](http://yapi.yishou.com/project/128/interface/api/33579) 的 **请求函数**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @标签 `爆版4.24.0`
 * @请求头 `POST /erp/Reject/getRejectDateDetail`
 * @更新时间 `2022-06-21 09:30:21`
 */
export const getRejectDateDetail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getRejectDateDetailRequestConfig, requestData), ...args);
};
getRejectDateDetail.requestConfig = getRejectDateDetailRequestConfig;
/**
 * 接口 [查询退换货页面供应商↗](http://yapi.yishou.com/project/128/interface/api/33595) 的 **请求配置**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @标签 `爆版4.24.0`
 * @请求头 `POST /erp/Reject/getSupplyIdByName`
 * @更新时间 `2022-05-26 10:54:21`
 */
const getSupplyIdByNameRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Reject/getSupplyIdByName",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_name", "page", "page_size"],
        properties: {
            supply_name: { type: "string" },
            page: { type: "string", description: "" },
            page_size: { type: "string", description: "" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        supply_id: { type: "string", description: '"14300"' },
                        supply_name: { type: "string", description: '"1-1111-MIA米雅"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"supply_id":"14300","supply_name":"1-1111-MIA米雅"},{"supply_id":"10419","supply_name":"1-1111-爱格狮顿"},{"supply_id":"12871","supply_name":"1-1111-诗菲瑾"},{"supply_id":"72782","supply_name":"1-11111-好难建供应商"},{"supply_id":"131052","supply_name":"1-DD-1111-军曹"},{"supply_id":"9193","supply_name":"1111布艺零点"},{"supply_id":"16023","supply_name":"2-A-161111-张帆"},{"supply_id":"100000","supply_name":"4-222-1111"},{"supply_id":"16044","supply_name":"99-9街-0722-水果联盟1111"},{"supply_id":"72629","supply_name":"负1-B-11111-LV"},{"supply_id":"72692","supply_name":"负2-A-111111-乌龙茶"}]',
            },
            total: { type: "integer", description: "11" },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getSupplyIdByName",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [查询退换货页面供应商↗](http://yapi.yishou.com/project/128/interface/api/33595) 的 **请求函数**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @标签 `爆版4.24.0`
 * @请求头 `POST /erp/Reject/getSupplyIdByName`
 * @更新时间 `2022-05-26 10:54:21`
 */
export const getSupplyIdByName = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getSupplyIdByNameRequestConfig, requestData), ...args);
};
getSupplyIdByName.requestConfig = getSupplyIdByNameRequestConfig;
/**
 * 接口 [退换货报表-筛选项↗](http://yapi.yishou.com/project/128/interface/api/33657) 的 **请求配置**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @标签 `#2619退换货报表优化`
 * @请求头 `GET /erp/Reject/listReportOptions`
 * @更新时间 `2022-06-20 14:52:52`
 */
const listReportOptionsRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Reject/listReportOptions",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: {
            dg_member: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        value: { type: "string", description: '"1562"' },
                        label: { type: "string", description: '"买手部负责人组"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"value":"1562","label":"买手部负责人组"}]',
            },
            market: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        value: { type: "string", description: '"1"' },
                        label: { type: "string", description: '"广州十三行"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"value":"1","label":"广州十三行"}]',
            },
            purchase_group: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        value: { type: "string", description: '"1"' },
                        label: { type: "string", description: '"香香"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"value":"1","label":"香香"}]',
            },
            city: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: "integer" }, label: { type: "string", description: '"全部"' } },
                    additionalProperties: false,
                },
                description: '[{"value":0,"label":"全部"},{"value":1,"label":"广州"}]',
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "listReportOptions",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [退换货报表-筛选项↗](http://yapi.yishou.com/project/128/interface/api/33657) 的 **请求函数**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @标签 `#2619退换货报表优化`
 * @请求头 `GET /erp/Reject/listReportOptions`
 * @更新时间 `2022-06-20 14:52:52`
 */
export const listReportOptions = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(listReportOptionsRequestConfig, requestData), ...args);
};
listReportOptions.requestConfig = listReportOptionsRequestConfig;
/**
 * 接口 [售后点货-工单详情↗](http://yapi.yishou.com/project/128/interface/api/33691) 的 **请求配置**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @请求头 `POST /erp/Work/getWorkDetailForDaBiao`
 * @更新时间 `2022-06-23 16:48:44`
 */
const getWorkDetailForDaBiaoRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Work/getWorkDetailForDaBiao",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        title: "empty object",
        properties: { work_id: { type: "string", description: "工单id" } },
        required: ["work_id"],
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            info: {
                type: "object",
                properties: {
                    work_id: { type: "string", description: '"1595076"' },
                    goods_name: { type: "string", description: '"百货其他  售后拦截商品1#  345"' },
                    goods_no: { type: "string", description: '"1159500001"' },
                    co_val: { type: "string", description: '"黑色"' },
                    si_val: { type: "string", description: '"XS"' },
                    tally_num: { type: "string", description: '"6"' },
                    problem_type: { type: "string", description: '"掉色"' },
                    problem_desc: { type: "string" },
                    service_remark: { type: "string" },
                    can_edit_address: { type: "string", description: '"0"' },
                    parts: { type: "string", description: '"无"' },
                    origin: { type: "string", description: '"1"' },
                    cat_name: { type: "string", description: '"百货其他"' },
                    user_id: { type: "string", description: '"2838351"' },
                    co_id: { type: "string", description: '"1017"' },
                    si_id: { type: "string", description: '"31"' },
                    goods_number: { type: "string", description: '"20"' },
                    back_shipping_num: { type: "string", description: '"123"' },
                    rec_id: { type: "string", description: '"1573034002"' },
                    order_id: { type: "string", description: '"7946002"' },
                    work_type: { type: "string", description: '"退货"' },
                    goods_imgs: {
                        type: "array",
                        items: {
                            type: "string",
                            description: '"https://img4.yishouapp.com/oss/goods/color/thumb/2020/8/25/9f20a0a73ffe7e849fd9a618d4287123.jpg?x-image-process=image/resize,w_600"',
                        },
                        description: '["https://img4.yishouapp.com/oss/goods/color/thumb/2020/8/25/9f20a0a73ffe7e849fd9a618d4287123.jpg?x-image-process=image/resize,w_600","https://img4.yishouapp.com/oss/goods/img/model/2020/8/25/88c22b1dee7a66826eca674683c33de4.jpg?x-image-process=image/resize,w_600"]',
                    },
                    problem_imgs: { type: "array", description: "[]" },
                    problem_type_id: { type: "array", items: { type: "string", description: '"1"' }, description: '["1","32"]' },
                    default_types: {
                        type: "object",
                        properties: {
                            reg_type: { type: "integer", description: "2" },
                            blp_type: { type: "integer", description: "9" },
                        },
                        additionalProperties: false,
                    },
                    defect_text: { type: "string", description: '"领子,肩膀"' },
                    can_return_exchange: { type: "boolean", description: "true" },
                    refund_reason: { type: "string", description: '"无"' },
                    reg_type: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: {
                                text: { type: "string", description: '"良品"' },
                                key: { type: "integer", description: "1" },
                                disabled: { type: "boolean" },
                            },
                            additionalProperties: false,
                        },
                        description: '[{"text":"良品","key":1,"disabled":false},{"text":"退换","key":2,"disabled":false},{"text":"次品","key":3,"disabled":false},{"text":"错发","key":4,"disabled":false}]',
                    },
                    can_exchange_num: { type: "integer", description: "6" },
                },
                additionalProperties: false,
            },
            address: { type: "array", description: "[]" },
            gb_tag: { type: "string" },
            no_return: {
                type: "object",
                properties: {
                    no_return_goods_no: { type: "integer", description: "1" },
                    no_return_goods_tips: { type: "string", description: '"提示文案呢???"' },
                    no_return_goods_tips_time: { type: "integer", description: "3" },
                },
                additionalProperties: false,
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getWorkDetailForDaBiao",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [售后点货-工单详情↗](http://yapi.yishou.com/project/128/interface/api/33691) 的 **请求函数**
 *
 * @分类 [售后管理↗](http://yapi.yishou.com/project/128/interface/api/cat_2287)
 * @请求头 `POST /erp/Work/getWorkDetailForDaBiao`
 * @更新时间 `2022-06-23 16:48:44`
 */
export const getWorkDetailForDaBiao = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getWorkDetailForDaBiaoRequestConfig, requestData), ...args);
};
getWorkDetailForDaBiao.requestConfig = getWorkDetailForDaBiaoRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/erpAfterSale.js